// Heading-only org card — title/sub (+ optional actions) sit in their own container
// so the data below can live in a separate card.
import type { ReactNode } from 'react';

export interface OrgSectionHeadingProps {
  title: string;
  sub?: ReactNode;
  actions?: ReactNode;
  /** Heading row only, for use inside an org panel or section. */
  plain?: boolean;
}

export default function OrgSectionHeading({
  title,
  sub,
  actions,
  plain = false,
}: OrgSectionHeadingProps) {
  const header = (
    <div className="org-section-header is-flush">
      <div>
        <h2 className="org-section-title">{title}</h2>
        {sub ? <p className="org-section-sub">{sub}</p> : null}
      </div>
      {actions ? <div className="org-section-actions">{actions}</div> : null}
    </div>
  );
  if (plain) return <div className="org-panel-heading">{header}</div>;
  return <section className="org-section org-section--heading">{header}</section>;
}
